import { useState } from 'react';
import Select from '../ui/Select';

interface TimeSelectorProps {
  onTimeChange: (time: string) => void;
  selectedTime?: string;
}

const TIMES_BRASILEIRO = [
  'América-MG',
  'Athletico-PR',
  'Atlético-GO',
  'Atlético-MG',
  'Avaí',
  'Bahia',
  'Botafogo',
  'Bragantino',
  'Ceará',
  'Chapecoense',
  'Corinthians',
  'Coritiba',
  'Criciúma',
  'Cruzeiro',
  'Cuiabá',
  'Flamengo',
  'Fluminense',
  'Fortaleza',
  'Goiás',
  'Grêmio',
  'Guarani',
  'Internacional',
  'Juventude',
  'Náutico',
  'Palmeiras',
  'Paraná',
  'Ponte Preta',
  'Portuguesa',
  'Red Bull Bragantino',
  'Santos',
  'São Paulo',
  'Sport',
  'Vasco',
  'Vitória'
];

export default function TimeSelector({ onTimeChange, selectedTime }: TimeSelectorProps) {
  return (
    <div className="relative">
      <label className="block text-sm font-bold mb-3">Time do Coração</label>
      <Select
        value={selectedTime || ''}
        onChange={(v) => onTimeChange(String(v))}
        options={TIMES_BRASILEIRO.map(t => ({ value: t, label: t }))}
        placeholder="Selecione seu time do coração"
        searchable
        searchPlaceholder="Buscar time..."
      />
      {!selectedTime && (
        <p className="mt-2 text-sm text-red-400">⚠️ Time do coração é obrigatório para Timemania</p>
      )}
    </div>
  );
}
